class DrugGroup {
  constructor(title, description) {
    this.title = title;
    this.description = description;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      confimType: '',
      drugGroupId: null,
      searchTitle: '',
      disabelConfirm: false,
      addFlag: false,
      modalTitle: '',
      showAddEditModal: false,
      modalIcon: '',
      drugGroupManagmentInformationTableHeaders: [
        { text: 'ردیف', value: 'counter', align: 'center' },
        { text: 'عنوان', value: 'title', align: 'center' },
        { text: 'توضیحات', value: 'description', align: 'center' },
        { text: 'عملیات', value: 'actions', sortable: false, align: 'center' },
      ],
    };
  },
  methods: {
    enableAddEditFunction: function (type, id) {
      if (type == 1) {
        this.modalTitle = 'افزودن گروه دارویی';
        this.modalIcon = 'mdi-plus';
        this.addFlag = true;
        this.confimType = 'add';
        this.showAddEditModal = true;
      } else if (type == 2) {
        this.modalTitle = 'ویرایش گروه دارویی';
        this.modalIcon = 'mdi-pencil';
        this.confimType = 'edit';
        this.addFlag = false;
        this.getDrugGroupFunction(id);
        this.showAddEditModal = true;
      }
    },
    cancelAddEditFunction: function () {
      this.drugGroup = new DrugGroup('', '');
      this.showAddEditModal = false;
    },
    showConfirmDialogFunction: function () {
      if (this.confimType == 'add') {
        this.addDrugGroupFunction();
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.title = 'ویرایش گروه دارویی';
        this.$refs.confirm.text = 'از ویرایش گروه دارویی اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.title = 'حذف گروه دارویی';
        this.$refs.confirm.text = 'از حذف گروه دارویی اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType == 'add') {
        this.disabelConfirm = true;
        this.addDrugGroupFunction();
      } else if (this.confimType == 'edit') {
        this.disabelConfirm = true;
        this.editDrugGroupFunction();
      } else if (this.confimType == 'delete') {
        this.disabelConfirm = true;
        this.deleteDrugGroupFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confimType == 'add') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    //delete
    showDeleteConfirmFunction: function (id) {
      this.drugGroupId = id;
      this.confimType = 'delete';
      this.showConfirmDialogFunction();
    },
  },
};
